import { useExtSubmission } from "api";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 *
 * @User : 이연우
 * @Date : 2023.08.21
 * @file : cpmAuth.js
 * @Desc : 권한 체크
 */
export const CpmAuth = () => {
  const location = useLocation();
  const extSubmission = useExtSubmission();
  const checkMenu = ["cpds0010e01", "cpbr0010e01", "cpbr0030e01", "cprp0010e01", 'cprp0050e01']  // 체크하고 싶은 페이지 코드 리스트
  const loginFree = ["upSimulation",  ]    //로그인 필요없음
  const pathname = location.pathname.replace('/', '');
  const paramsProps = location?.state ; //페이지 링크
  

  const cpmAuth = async () => {
   const compTypeCd = sessionStorage.getItem("compTypeCd") ||"";
   const sysDivCd = sessionStorage.getItem("sysDivCd" )||"";
   
   if(paramsProps){
     sessionStorage.setItem("menuId", paramsProps.menuId  );
   }
    
    if(!(compTypeCd === 'SAA01' || ( compTypeCd === "SAA03" && sysDivCd.indexOf("POB04") >=0 )) ){
       alert("권한이 없습니다. ")
       window.location.replace('/portal/main/index.do')
       return ;
    }
    
    await extSubmission("/cpm/com/menu/subList.do", {}, (e, data) => {
      if (e) console.log(e);
      const { listMenuAll } = data.result;
      
      const menu = [...new Set(listMenuAll.map((el) => el.scrnPgmId))];
      if(checkMenu.includes(pathname)){
        if(!menu.includes(pathname)){
          window.location.replace('/portal/main/index.do')
          return ;
        }
      }
      sessionStorage.setItem("scrnPgmId", pathname );
      let menuId = "";
      listMenuAll.filter((el) => el.scrnPgmId === pathname).forEach((el) => {
          menuId = el.menuId;
          sessionStorage.setItem("menuId",   el.menuId  );
          sessionStorage.setItem("mediaTotChcYn",  el.mediaTotChcYn );
      })
        //Connect Log
        cpmConntLog(menuId)  ;
    });
  };
  
  
    const cpmConntLog = async (menuId = "cpm") => {
        const userId = sessionStorage.getItem("userId" )||"mcadmin";
        const scrnPgmId = sessionStorage.getItem("scrnPgmId" )|| pathname ;
        const parms ={
            userId : userId
          , menuId  : menuId
          , scrnPgmId : scrnPgmId
        }

        await extSubmission("/cpm/com/main/connectLog.do", parms, (e, data) => {
          if (e) console.log(e);
        });
  };
  

  useEffect(() => {
      //세션정보
      extSubmission(
          "/cpm/com/main/getSession.do",
          {},
          (e, data) => {
              try{
                  if(data.result === null || data.result === undefined ) {
                      sessionStorage.clear()  ;
                      return false
                  }
                  if((data.result.userId ?? "") === "" ){
                      sessionStorage.clear()  ;
                  }else{
                      //세션Storage
                      sessionStorage.setItem("userId",  data.result.userId);
                      sessionStorage.setItem("userNm",  data.result.userNm );
                      sessionStorage.setItem("compTypeCd",   data.result.compTypeCd );
                      sessionStorage.setItem("compTypeNm",   data.result.compTypeNm );
                      sessionStorage.setItem("athrCd",   data.result.athrCd );
                      sessionStorage.setItem("compId",   data.result.compId );
                      sessionStorage.setItem("deptId",   data.result.curDeptId );
                      sessionStorage.setItem("saleDeptYn",   data.result.saleDeptYn );
                      sessionStorage.setItem("sysDivCd",   data.result.sysDivCd );
                  }
              }catch (e) {
                  sessionStorage.clear()  ;
              }
          },
          'N'
      );
      
      sessionStorage.setItem("menuId",   "" );
      sessionStorage.setItem("mediaTotChcYn",   "" );
      sessionStorage.setItem("scrnPgmId",   "" );

      if( !(loginFree.includes(pathname) || pathname.indexOf("front/")>=0) &&  (sessionStorage.getItem("userId") ??"") !== "" ) {
          cpmAuth()
      }else{
          cpmConntLog("cpm") ;
      }
      
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location])
  
  return (<></>)
};